export const SEARCH_UPDATE = 'SEARCH_UPDATE';
export const SEARCH_SET_PAGES = 'SEARCH_SET_PAGES';
export const SEARCH_UPDATE_COURSES = 'SEARCH_UPDATE_COURSES';
export const SEARCH_SCHOOLS_UPDATE = 'SEARCH_SCHOOLS_UPDATE';
export const SEARCH_INSTITUTIONS_UPDATE = 'SEARCH_INSTITUTIONS_UPDATE';
export const SEARCH_VALUE_INSTITUTIONS_UPDATE =
  'SEARCH_VALUE_INSTITUTIONS_UPDATE';
